<template>
  <div>
    <el-dialog :visible.sync="isQuotationRecord" :show-close= false width="96%" top="50px" class="pub_dialog">
      <template v-slot:title>
        <ul class="drawer_title">
          <li>报价记录</li>
          <li>
            <el-button type="danger" @click="closeQuotationRecord" style="margin-top: -10px;">关 闭</el-button>
          </li>
        </ul>
      </template>
      <el-row class="drawerBaojiaDiv">
        <el-col :span="3">
          <template>
            <el-table :data="getDataAllList" border style="width: 100%">
              <el-table-column label="报价记录" align="center">
                <template scope="scope">
                  <span @click="endQuotationTime(scope.row)">{{scope.row.QuoteTime}}<strong v-if="scope.row.Status == '已中标'">-已中标</strong></span>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-col>
        <el-col :span="21">
          <div class="drawerInformation">
            <div class="purchasingGoods">基本信息</div>
            <div class="divBasics">
              <p>竞价品类:　<span>{{formDetails.BrandType}}</span></p>
              <p>竞价品牌:　<span>{{formDetails.Brand}}</span></p>
              <p>状态:　<span>{{formDetails.Status}}</span></p>
            </div>
            
            <div class="purchasingGoods">报价商品</div>
            <el-table :data="formDetails.QuotationGoods" stripe border style ="margin-top:15px">
              <el-table-column prop="GoodModelCode" label="商品名称"  align="center">
                <template scope="scope"><span>{{scope.row.GoodsName}}</span></template>
              </el-table-column>
              <el-table-column prop="GoodModelCode" label="商品型号"  align="center">
                <template scope="scope"><span>{{scope.row.GoodsCode}}</span></template>
              </el-table-column>
              <el-table-column prop="Counts" label="风格" align="center">
                <template scope="scope"><span>{{scope.row.Style}}</span></template>
              </el-table-column>
              <el-table-column prop="singleprice" label="单位"  align="center">
                <template scope="scope"><span>{{scope.row.Unit}}</span></template>
              </el-table-column>
              <el-table-column prop="PaidPrice" label="参考图片/图纸" align="center">
                <template scope="scope">
                  <span @click="seeQuoteThumbnail(scope.row.Imgs)" :style="{color: scope.row.Imgs.length == 0 ? '#ccc' : '#F56C6C'}">查看({{scope.row.Imgs.length}})张</span>
                </template>
              </el-table-column>
              <el-table-column prop="Counts" label="数量" align="center">
                <template scope="scope"><span>{{scope.row.Counts}}</span></template>
              </el-table-column>
              <el-table-column prop="PaidPrice" label="单价" align="center">
                <template scope="scope"><span>{{scope.row.UnitPrice}}</span></template>
              </el-table-column>
              <el-table-column prop="Counts" label="备注说明" align="center">
                <template scope="scope"><span>{{scope.row.Remark}}</span></template>
              </el-table-column>
            </el-table>
            <div class="total" v-if="isQuotationRecord">
              <span><strong>总计：</strong></span>
              <span><strong>{{totalNumber}}</strong></span>
              <span><strong>{{totalUnitPrice}}</strong></span>
              <span><strong>{{theSum}}</strong></span>
            </div>
            <div class="divBasics">
              <p>竞标价:　<span>¥ {{formDetails.BidPrice}}</span></p>
              <p>平台佣金:　<span>{{(formDetails.Commission * 100).toFixed(2)}}% </span></p>
              <p>平台应得佣金:　<span>¥ {{formDetails.TotalbidPrice}}</span></p>
            </div>

            <div class="purchasingGoods">报价要求</div>
            <div>
              <div class="classRequestForQuotation">
                <p>报价有效截止日:　<span>{{formDetails.QuoteEffectiveDate}}</span></p>
                <p>计划送货时间：付款后 <span>{{formDetails.DeliveryDaysAfterPay}}</span> 天后送货</p>
              </div>
              <div class="classRequestForQuotation">
                <p>备注:　<span>{{formDetails.QuoteRemark}}</span></p>
              </div>
            </div>
            
            <div v-if="formDetails.Status == '已中标'">
              <!-- 客户服务要求 -->
              <div class="purchasingGoods">客户服务要求</div>
              <div class="classCustomerService">
                <p>配送地址:　<span>{{formDetails.DeliveryZone}}</span></p>
                <p>上楼方式:　<span>{{formDetails.UpstairsType}}</span></p>
                <p>楼层:　<span>{{formDetails.FloorNumber}}</span></p>
                <p>是否需要发票:　<span>{{formDetails.IsNeedInvoice}}</span></p>
              </div>
              <div class="divBasics">
                <p>是否需要安装:　<span>{{formDetails.IsNeedInstallation}}</span></p>
                <p>运费承担:　<span>{{formDetails.IsBearDeliveryFee}}</span></p>
                <p>期望送货日期:　<span>{{formDetails.DeliveryDate}}</span></p>
              </div>
              <div class="divBasics">
                <p>客户要求备注:　<span>{{formDetails.InquiryRemark}}</span></p>
              </div>
            </div>
            
            <!-- 弹框 取消按钮 -->
            <div class="preservation_div" v-if="formDetails.Status != '已中标'">
              <el-button @click="isQuotationRecord = false">取消</el-button>
            </div>
            <!-- 已中标 弹框内按钮 -->
            <div class="preservation_div" v-if="formDetails.Status == '已中标'">
              <el-button type="danger" @click="endModifyQuotation">修改报价单</el-button>
              <el-button type="danger" @click="endBusinessQuotation">已与客户沟通确认，生成订单发送给客户</el-button>
            </div>

          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 商家报价 -->
    <BusinessQuotation :inquiryId="inquiryId" :inquiryNo="inquiryNo" :formDetails="formDetails" ref="refBusinessQuotation" @add-comment="appendComment"/>
    <!-- 查看大图缩略图 -->
    <ViewPicture ref="refViewPicture"/>
  </div>
</template>
<script>
import { getSendQuote, } from "../../api/api";
import BusinessQuotation from './BusinessQuotation';
import ViewPicture from './ViewPicture';
  export default {
    name: "QuotationRecord",
    props: ['inquiryId', 'inquiryNo', 'dataAllList'],
    // props: {
    //   inquiryId: String,
    //   inquiryNo: String,
    //   dataAllList: Array
    // },
    data () {
      return {
        quotationId: "", // 报价单ID
        // inquiryId: "", // 询价ID
        // inquiryNo: "", // 询价单号
        isQuotationRecord: false, // 报价记录弹框
        getDataAllList: [], // 报价记录列表
        formDetails: {}, // 报价信息回显
      }
    },
    components: {
      BusinessQuotation,
      ViewPicture
    },
    methods: {
      // 初始化
      init () {
        this.getDataAllList = this.dataAllList;
        // this.inquiryId = this.inquiryId;
        // this.inquiryNo = this.inquiryNo;
        this.isQuotationRecord = true;
        this.endQuotationTime(this.getDataAllList[0]);
      },
      // 点击修改报价单
      endModifyQuotation() {
        this.$nextTick(() => {
          this.$refs.refBusinessQuotation.init();
        })
      },
      // 发起-已与客户沟通确认，生成订单发送给客户
      endBusinessQuotation() {
        var addParams = {
          quoteId: this.quotationId, // 报价单ID
        };
        getSendQuote(addParams).then(data => {
          if(data.ResultCode == 1){
            this.$swal({
              type: "success",
              text:"操作成功"
            });
            this.isQuotationRecord = false;
            this.$emit('closeSee');
            this.getorder();
          }else if(data.ResultCode in {0:0,2:2}){
            this.$swal({
              type:'error',
              text: data.ResultMsg,
            })
          }
        })
      },
      // 点击报价记录时间
      endQuotationTime(row) {
        this.formDetails = row;
        this.quotationId = row.Id;
      },
      appendComment (item) {
        this.getDataAllList = item;
        this.endQuotationTime(this.getDataAllList[0]);
      },
      // 点击查看报价记录缩略图
      seeQuoteThumbnail(imgs) {
        if (imgs.length == 0) {
          return false;
        }
        this.$nextTick(() => {
          this.$refs.refViewPicture.init(imgs);
        })
      },
      // 关闭报价记录弹框
      closeQuotationRecord() {
        this.isQuotationRecord = false;
      },
    },
    computed: {
      // 合计数量
      totalNumber() {
        let zongshu = 0;
        this.formDetails.QuotationGoods.map(item => {
          zongshu += Number(item.Counts);
        })
        return zongshu;
      },
      // 合计单价
      totalUnitPrice() {
        let zongji = 0;
        this.formDetails.QuotationGoods.map(item => {
          zongji += Number(item.UnitPrice);
        })
        return zongji.toFixed(2);
      },
      theSum() {
        let zong = 0;
        this.formDetails.QuotationGoods.map(item => {
          zong += Number(item.UnitPrice) * Number(item.Counts);
        })
        return zong.toFixed(2);
      }
    },
  }
</script>
<style scoped>
.drawer_title {
  padding-left: 0;
  display: flex;
  justify-content: space-between;
}
.drawer_title>li:first-child{
  font-size: 17px;
  font-weight: bolder;
  color: #333;
}
.drawerBaojiaDiv {
  width: 100%;
  margin: 0 auto;
}
/* 报价记录 */
.pub_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
}
.drawerInformation {
  width: 96%;
  height: 80vh;
  overflow: scroll;
  margin: 0 auto;
}
.purchasingGoods {
  width: 100%;
  font-weight: bold;
  font-size: 15px;
  color: #333;
}
.divBasics {
  width: 60%;
  display: flex;
  justify-content: space-between;
}
.divBasics>p {
  font-size: 15px;
  color: #888;
}
.divBasics>p>span {
  font-weight: bold;
  font-size: 15px;
  color: #666;
}
/* 报价要求 */
.classRequestForQuotation {
  width: 60%;
  display: flex;
  justify-content: space-between;
}
.classRequestForQuotation>p {
  font-size: 15px;
  color: #888;
}
.classRequestForQuotation>p>span {
  font-weight: bold;
  font-size: 15px;
  color: #666;
}
/* 客户服务要求 */
.classCustomerService {
  width: 80%;
  display: flex;
  justify-content: space-between;
}
.classCustomerService>p:first-child {
  width: 100%;
}
.classCustomerService>p {
  width: 50%;
  font-size: 15px;
  color: #888;
}
.classCustomerService>p>span {
  font-weight: bold;
  font-size: 15px;
  color: #666;
}
.total {
  width: 99.9%;
  overflow: hidden;
  height: 36px;
  line-height: 36px;
  border-bottom: 1px solid #eee;
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
}
.total>span:first-child {
  width: 62.6%;
  display: inline-block;
  text-align: right;
  border-right: 1px solid #eee;
}
.total>span {
  width: 12%;
  text-align: center;
  display: inline-block;
  border-right: 1px solid #eee;
}
.total>span:last-child {
  border-right: none;
}
/* 按钮区域 */
.preservation_div {
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
.preservation_div:last-child {
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// QuotationRecord.vue?5430e120